import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import useFetchExpenseBalance from 'src/Hooks/Queries/useFetchExpenseBalance';
import useNavigateKeepingSearch from 'src/Hooks/Shared/useNavigateKeepingSearch';
import { trackSelfStatementOpened } from 'src/Services/Mixpanel/events';

import styles from './SendMyStatementButton.module.scss';

// Kept in code so a bad preview can hide the button without a revert. Flip to false if the
// SELF preview endpoint stops returning one line per debtor with a pre-filled amount.
const FEATURE_SELF_STATEMENT = true;

const SendMyStatementButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigateKeepingSearch();
  const { data: balance } = useFetchExpenseBalance();

  if (!FEATURE_SELF_STATEMENT) return null;
  if (!balance || balance.myNetBalance <= 0) return null;

  const handleClick = () => {
    trackSelfStatementOpened();
    navigate('fund-calls/new?scope=SELF&type=STATEMENT');
  };

  return (
    <div className={styles.container}>
      <Button onClick={handleClick}>
        {t('expenses.userBalance.sendMyStatement', 'Envoyer mon relevé')}
      </Button>
    </div>
  );
};

export default SendMyStatementButton;
